module.exports = __webpack_public_path__ + "static/media/reportIcon.4165da2a.svg";